module.exports = __webpack_public_path__ + "media/images/Puregold-e7779973e30b419ad1b8f41b42382642.png";